import { Breadcrump } from "./breadcrump";

export class PageHeader {
    PageCaption: string;
    IconClass: string;  
    Breadcrump: Array<Breadcrump>

    constructor() {
        this.PageCaption = ""; 
        this.IconClass = ""; 
        this.Breadcrump = [];
    }
}